import React, { useState } from "react";

function Tab({ label, activeTab, onClick }) {
  return (
    <div
      className={`tab ${activeTab === label ? "active" : ""}`}
      onClick={() => onClick(label)}
    >
      {label}
    </div>
  );
}

export default function Tabs({ children }) {
  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const onClickTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="tabs">
      <div className="tab-list">
        {children.map((child) => {
          const { label } = child.props;

          return (
            <Tab
              key={label}
              label={label}
              activeTab={activeTab}
              onClick={onClickTab}
            />
          );
        })}
      </div>
      <div className="tab-content">
        {children.map((child) => {
          if (child.props.label !== activeTab) return undefined;
          return child.props.children;
        })}
      </div>
    </div>
  );
}
